import { render, staticRenderFns } from "./ModifyCabinetAddonsModal.vue?vue&type=template&id=517bd76b&"
import script from "./ModifyCabinetAddonsModal.vue?vue&type=script&lang=js&"
export * from "./ModifyCabinetAddonsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports